// A missing day makes a period partial, but does not erase its observed totals.
// Require reported evidence for each metric; absent values never become zero.
export const hasObservedMetric = (row, metric) => {
  const coverage = row.metricCoverage?.[metric];
  return Number.isFinite(row.metrics?.[metric]) && row.metrics[metric] >= 0
    && (coverage?.complete === true || coverage?.reported > 0
      || (!coverage && row.source === 'performance_saved_reporting' && row.reportedDays > 0));
};
export const hasPartialReporting = (row, metrics) => row.complete === false
  || metrics.some(metric => row.metricCoverage?.[metric]?.complete !== true);

// Dashboard rows come from saved Performance, not provider report snapshots.
// Do not invent provider coverage, time zones or measurement verification.
export const isSavedReport = report => report.reportingSource === 'performance_saved_reporting'
  && (report.rows || []).every(row => row.source === 'performance_saved_reporting')
  && (report.previous || []).every(row => row.source === 'performance_saved_reporting');
export const hasConsistentReporting = (row, saved) => saved
  ? row.reportFreshness?.measurementConsistent !== false
  : row.reportFreshness?.measurementConsistent === true;
export const savedReportingNotice = 'Observed totals from saved Performance reports. Conversion definitions and reporting time zones are not independently verified. Campaign mappings may be incomplete; these are workspace campaign totals, not deduplicated provider totals.';
export function hasSavedMappingOverlap(report) {
  const owners = new Map();
  const included = new Map((report.rows || []).map(row => [row.campaignId || row.id, row.platform]));
  for (const campaign of report.performanceDataset?.campaigns || []) {
    if (!included.has(campaign.id)) continue;
    const advertiser = String(campaign.advertiser_id || '').replaceAll('-', '').replace(/^act_/, '');
    if (!advertiser) continue;
    for (const id of String(campaign.platform_campaign_id || '').split(',').map(value => value.trim()).filter(Boolean)) {
      const key = JSON.stringify([included.get(campaign.id), advertiser, id]);
      if (owners.has(key) && owners.get(key) !== campaign.id) return true;
      owners.set(key, campaign.id);
    }
  }
  return false;
}
